import styled from 'styled-components';
import {
  fontVariables,
  colorsVariables
} from '@trustedshops/tps-seo-shared-frontend-react-components';
import { minWidth } from 'helpers/buildMediaQueries';

export const RelevancyExplanationModalBody = styled.div`
  line-height: ${fontVariables.LINE_HEIGHT_L};
  color: ${colorsVariables.GRAY_800};
  display: flex;
  flex-direction: column;
  white-space: pre-line;
  text-align: left;

  ${minWidth('md', `color: ${colorsVariables.WHITE};`)};
`;
